export const TELIA = 'TELIA';
export const CUSTOMER = 'CUSTOMER';
export const types = {TELIA, CUSTOMER};
export default types;
